// source: pbtypes/gen/scan_output/scan_data_segment.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_output_scan_photo_pb = require('../../../pbtypes/gen/scan_output/scan_photo_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_output_scan_photo_pb);
goog.exportSymbol('proto.scan_output.ScanDataSegment', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_output.ScanDataSegment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scan_output.ScanDataSegment.repeatedFields_, null);
};
goog.inherits(proto.scan_output.ScanDataSegment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_output.ScanDataSegment.displayName = 'proto.scan_output.ScanDataSegment';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scan_output.ScanDataSegment.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_output.ScanDataSegment.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_output.ScanDataSegment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_output.ScanDataSegment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_output.ScanDataSegment.toObject = function(includeInstance, msg) {
  var f, obj = {
scanDataSegmentId: jspb.Message.getFieldWithDefault(msg, 7, ""),
scanSkillStateId: jspb.Message.getFieldWithDefault(msg, 8, ""),
flightId: jspb.Message.getFieldWithDefault(msg, 1, ""),
logDir: jspb.Message.getFieldWithDefault(msg, 2, ""),
vehicleId: jspb.Message.getFieldWithDefault(msg, 3, ""),
vehicleName: jspb.Message.getFieldWithDefault(msg, 4, ""),
vehicleModel: jspb.Message.getFieldWithDefault(msg, 9, ""),
takeoffUclock: jspb.Message.getFieldWithDefault(msg, 5, 0),
photosList: jspb.Message.toObjectList(msg.getPhotosList(),
    pbtypes_gen_scan_output_scan_photo_pb.ScanPhoto.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_output.ScanDataSegment}
 */
proto.scan_output.ScanDataSegment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_output.ScanDataSegment;
  return proto.scan_output.ScanDataSegment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_output.ScanDataSegment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_output.ScanDataSegment}
 */
proto.scan_output.ScanDataSegment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScanDataSegmentId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setScanSkillStateId(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFlightId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLogDir(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVehicleId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVehicleName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVehicleModel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setTakeoffUclock(value);
      break;
    case 6:
      var value = new pbtypes_gen_scan_output_scan_photo_pb.ScanPhoto;
      reader.readMessage(value,pbtypes_gen_scan_output_scan_photo_pb.ScanPhoto.deserializeBinaryFromReader);
      msg.addPhotos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_output.ScanDataSegment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_output.ScanDataSegment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_output.ScanDataSegment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_output.ScanDataSegment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScanDataSegmentId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getScanSkillStateId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLogDir();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVehicleName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVehicleModel();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTakeoffUclock();
  if (f !== 0) {
    writer.writeSint64(
      5,
      f
    );
  }
  f = message.getPhotosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      pbtypes_gen_scan_output_scan_photo_pb.ScanPhoto.serializeBinaryToWriter
    );
  }
};


/**
 * optional string scan_data_segment_id = 7;
 * @return {string}
 */
proto.scan_output.ScanDataSegment.prototype.getScanDataSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.setScanDataSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string scan_skill_state_id = 8;
 * @return {string}
 */
proto.scan_output.ScanDataSegment.prototype.getScanSkillStateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.setScanSkillStateId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string flight_id = 1;
 * @return {string}
 */
proto.scan_output.ScanDataSegment.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string log_dir = 2;
 * @return {string}
 */
proto.scan_output.ScanDataSegment.prototype.getLogDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.setLogDir = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vehicle_id = 3;
 * @return {string}
 */
proto.scan_output.ScanDataSegment.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.setVehicleId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string vehicle_name = 4;
 * @return {string}
 */
proto.scan_output.ScanDataSegment.prototype.getVehicleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.setVehicleName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string vehicle_model = 9;
 * @return {string}
 */
proto.scan_output.ScanDataSegment.prototype.getVehicleModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.setVehicleModel = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional sint64 takeoff_uclock = 5;
 * @return {number}
 */
proto.scan_output.ScanDataSegment.prototype.getTakeoffUclock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.setTakeoffUclock = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated ScanPhoto photos = 6;
 * @return {!Array<!proto.scan_output.ScanPhoto>}
 */
proto.scan_output.ScanDataSegment.prototype.getPhotosList = function() {
  return /** @type{!Array<!proto.scan_output.ScanPhoto>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_scan_output_scan_photo_pb.ScanPhoto, 6));
};


/**
 * @param {!Array<!proto.scan_output.ScanPhoto>} value
 * @return {!proto.scan_output.ScanDataSegment} returns this
*/
proto.scan_output.ScanDataSegment.prototype.setPhotosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.scan_output.ScanPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scan_output.ScanPhoto}
 */
proto.scan_output.ScanDataSegment.prototype.addPhotos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.scan_output.ScanPhoto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scan_output.ScanDataSegment} returns this
 */
proto.scan_output.ScanDataSegment.prototype.clearPhotosList = function() {
  return this.setPhotosList([]);
};


goog.object.extend(exports, proto.scan_output);
